export const year2025 = [
  { year: 2025 },
  {
    name: "Bringing Animations to Life: Interactive dotLottie with JavaScript 🚀",
    author: "Karin Fam",
    type: "Workshop",
    link: "https://guild.host/events/bringing-animations-b37mq0",
    repo: "https://github.com/andreidobrinski/toronto-js-workshop-lottie-25-05-2025",
  },
  {
    name: "Data Governance Workshop (GDPR)",
    author: "InfoTrust",
    type: "Workshop",
    link: "https://infotrust.com/infotrust-data-governance-workshop/",
  },
];
